// extracted by mini-css-extract-plugin
export var main = "Layout-module--main--200a4";
export var menuIcon = "Layout-module--menu-icon--997a7";